module.exports = __webpack_public_path__ + "img/culture3.743f6c18.jpg";